import { defineAsyncComponent, defineComponent, inject, computed, ref, shallowRef, onMounted, onBeforeUnmount, watch, triggerRef, resolveComponent, resolveDirective, openBlock, createElementBlock, mergeProps, withModifiers, createElementVNode, createVNode, withCtx, createCommentVNode, withDirectives, createBlock, createTextVNode } from "vue";
import { u as useDefaults, _ as _export_sfc } from "../../_plugin-vue_export-helper-3194dc60.mjs";
import "../../index-64135f7d.mjs";
import "../../i18n-35335a5c.mjs";
import { b as boundUseI18n } from "../../_i18n-e414d464.mjs";
import "../../malarkeyTwilioAdapter-1c296255.mjs";
import "../../event-socket/malarkeyEventSocketAdapter.es.js";
import { d as debug } from "../../_debug-8b5c3032.mjs";
import "../../otpauth.esm-675c01d0.mjs";
import "../../sudo-bad5b55e.mjs";
import { f as fromMarkdownLike } from "../../helpers-674591c1.mjs";
import { u as useTheme } from "../../theme-96176369.mjs";
import "../../index-fd2245c5.mjs";
import "../../_commonjsHelpers-ca272635.mjs";
import "../../index-38c53cf2.mjs";
import "../../index-703c58ee.mjs";
import "../../index-13be80af.mjs";
import "joi";
import "../../getCurrentInstance-eec76705.mjs";
const style = "";
const EmojiPicker = defineAsyncComponent(() => import("../../emoji-picker.es-e6a1836f.mjs"));
const _sfc_main = defineComponent({
  name: "MalarkeyChatInputForm",
  components: {
    EmojiPicker
  },
  props: {
    /**
     * The conversation object that the chat input form is associated with.
     */
    conversation: {
      type: Object,
      default: void 0
    },
    /**
     * Handle the submission event instead of using the default behavior.
     */
    doOnSubmit: {
      type: Function,
      default: void 0
    },
    /**
     * Boolean for when the form is being submitted externally
     */
    isExternallySubmitting: {
      type: Boolean,
      default: false
    },
    /**
     * The model value to be used for v-mode on the text input field.
     */
    modelValue: {
      type: String,
      default: void 0
    },
    /**
     * Placeholder text for the text input field.
     */
    placeholder: {
      type: String,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when the text input field is resized
     */
    "resize",
    /**
     * Emitted when the text input field's model value is updated
     */
    "update:modelValue"
  ],
  setup(props, { emit }) {
    const { t } = boundUseI18n();
    const { current } = useTheme();
    const sounds = inject("sounds");
    const bus = inject("bus");
    const alert = inject("alert");
    const conversation = computed(() => props.conversation);
    const vTextInputDefaults = useDefaults({}, "VTextArea");
    const malarkeyChatInputFieldDefaults = useDefaults(
      {
        ...vTextInputDefaults,
        autoGrow: true,
        autofocus: "autofocus",
        noResize: true,
        rowHeight: 16,
        rows: 1,
        density: "compact"
      },
      "MalarkeyChatInputField"
    );
    const formElemBindings = computed(() => ({
      action: "#",
      method: "POST",
      style: {
        display: "block"
      },
      class: ["m-chat-input-form"]
    }));
    const contents = ref("");
    const field = ref(null);
    const fieldHeight = ref(0);
    const updateFieldHeight = () => {
      if (field.value) {
        fieldHeight.value = field.value.$el.clientHeight;
      }
    };
    const form = ref(
      null
    );
    const hasContents = computed(
      () => "string" === typeof contents.value && contents.value.trim().length > 0
    );
    const isLineBreaking = ref(false);
    const focus = () => {
      if (field.value) {
        const input = field.value.$el.querySelector("textarea");
        if (input) {
          requestAnimationFrame(() => {
            input.focus();
            input.selectionStart = input.selectionEnd = input.value.length;
          });
        }
      }
    };
    const submitting = ref(false);
    const isReplyTo = ref(void 0);
    const isReplyToContent = ref(void 0);
    const isUpdateOf = shallowRef(void 0);
    const onFormSubmit = async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if ("function" === typeof props.doOnSubmit) {
        try {
          props.doOnSubmit();
        } catch (e2) {
          debug("Error in doOnSubmit", e2);
        }
        return false;
      }
      if (!hasContents.value || isLineBreaking.value || submitting.value || !conversation.value) {
        return false;
      }
      submitting.value = true;
      let success;
      if ("undefined" !== typeof isUpdateOf.value) {
        try {
          const response = await isUpdateOf.value.updateBody(
            contents.value.trim()
          );
          debug("Message updated", response);
          success = true;
        } catch (e2) {
          debug("Error updating message", e2);
          if (e2.message === "Forbidden" && alert) {
            alert(
              "errors.chat.update.forbidden.title",
              "errors.chat.update.forbidden.text"
            );
          }
          success = false;
        }
      } else {
        try {
          const response = await conversation.value.prepareMessage().setBody(contents.value.trim()).setAttributes({
            isReplyTo: isReplyTo.value || null,
            isReplyToContent: isReplyToContent.value || null
          }).build().send();
          debug("Message sent", response);
          if (response) {
            conversation.value.advanceLastReadMessageIndex(response).then(() => {
              debug(`Advanced last read message index to ${response}`);
              if (bus) {
                bus.emit("conversation:read:index:advanced", {
                  local: true
                });
              }
            }).catch((e2) => {
              debug("Error advancing last read message index", e2);
            });
          }
          success = true;
        } catch (e2) {
          debug("Error sending message", e2);
          if (e2.message === "Forbidden" && alert) {
            alert(
              "errors.chat.send.forbidden.title",
              "errors.chat.send.forbidden.text"
            );
          }
          success = false;
        }
      }
      submitting.value = false;
      if (success) {
        if (sounds && "muted" !== conversation.value.notificationLevel) {
          try {
            sounds.play("onMessageSent");
          } catch {
          }
        }
        contents.value = "";
        isReplyTo.value = void 0;
        isReplyToContent.value = void 0;
        isUpdateOf.value = void 0;
        triggerRef(isUpdateOf);
      }
      focus();
      return false;
    };
    const onFieldKeydown = (e) => {
      updateFieldHeight();
      if (e.key === "Enter" && e.shiftKey) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        if ("string" !== typeof contents.value) {
          contents.value = "";
        }
        isLineBreaking.value = true;
        if (conversation.value) {
          conversation.value.typing().catch(() => {
          });
        }
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (form.value) {
          form.value.dispatchEvent(new Event("submit"));
        }
      } else {
        if (conversation.value) {
          conversation.value.typing().catch(() => {
          });
        }
      }
    };
    const onFieldKeyup = (e) => {
      updateFieldHeight();
      if (e.key === "Enter" && e.shiftKey) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        isLineBreaking.value = false;
      } else if (e.key === "Enter") {
        e.preventDefault();
      }
    };
    const onEventMessageRemovedMalicious = () => {
      if (alert) {
        alert(
          "errors.chat.message.removedMalicious.title",
          "errors.chat.message.removedMalicious.text"
        );
      }
    };
    let fieldFocusTimeout;
    let fieldBlurTimeout;
    const onFieldFocus = () => {
      emit("resize");
      if (fieldFocusTimeout) {
        clearTimeout(fieldFocusTimeout);
      }
      if (fieldBlurTimeout) {
        clearTimeout(fieldBlurTimeout);
      }
      fieldFocusTimeout = setTimeout(() => {
        emit("resize");
      }, 500);
    };
    const onFieldBlur = () => {
      emit("resize");
      if (fieldFocusTimeout) {
        clearTimeout(fieldFocusTimeout);
      }
      if (fieldBlurTimeout) {
        clearTimeout(fieldBlurTimeout);
      }
      fieldBlurTimeout = setTimeout(() => {
        emit("resize");
      }, 500);
    };
    const doFormSubmit = () => {
      if (form.value) {
        form.value.dispatchEvent(new Event("submit"));
      }
    };
    const onFieldResize = () => {
      emit("resize");
    };
    const isSubmitting = computed(
      () => submitting.value || props.isExternallySubmitting
    );
    const emojiButtonDisabled = computed(
      () => !conversation.value || isSubmitting.value
    );
    const emojiMenuOpen = ref(false);
    const selectEmoji = (emoji) => {
      contents.value += emoji.i;
      emojiMenuOpen.value = false;
      focus();
    };
    const emojiGroupNames = computed(() => ({
      smileys_people: t("malarkeyChat.emojis.smileys_people"),
      animals_nature: t("malarkeyChat.emojis.animals_nature"),
      food_drink: t("malarkeyChat.emojis.food_drink"),
      activities: t("malarkeyChat.emojis.activities"),
      travel_places: t("malarkeyChat.emojis.travel_places"),
      objects: t("malarkeyChat.emojis.objects"),
      symbols: t("malarkeyChat.emojis.symbols"),
      flags: t("malarkeyChat.emojis.flags")
    }));
    const emojiStaticTexts = computed(() => ({
      placeholder: t("malarkeyChat.emojis.placeholder"),
      skinTone: t("malarkeyChat.emojis.skinTone")
    }));
    const emojiPickerTheme = computed(
      () => current.value.dark ? "dark" : "light"
    );
    const onConversationMessageReply = (msg) => {
      if (!conversation.value || msg.conversation.sid !== conversation.value.sid || !msg.body) {
        return;
      }
      isReplyTo.value = msg.sid;
      isReplyToContent.value = msg.body;
    };
    const replyingToQuote = computed(
      () => isReplyToContent.value ? fromMarkdownLike(isReplyToContent.value) : void 0
    );
    const onConversationMessageEdit = (msg) => {
      if (!conversation.value || msg.conversation.sid !== conversation.value.sid || !msg.body) {
        return;
      }
      isUpdateOf.value = msg;
      triggerRef(isUpdateOf);
      if (msg.body) {
        contents.value = msg.body;
      }
    };
    onMounted(() => {
      updateFieldHeight();
      if (bus) {
        bus.on("conversation:message:reply", onConversationMessageReply, {
          local: true
        });
        bus.on("conversation:message:edit", onConversationMessageEdit, {
          local: true
        });
        bus.on(
          "event:message:removed:malicious",
          onEventMessageRemovedMalicious,
          {
            local: true
          }
        );
      }
    });
    onBeforeUnmount(() => {
      if (bus) {
        bus.off("conversation:message:reply", onConversationMessageReply, {
          local: true
        });
        bus.off("conversation:message:edit", onConversationMessageEdit, {
          local: true
        });
        bus.off(
          "event:message:removed:malicious",
          onEventMessageRemovedMalicious,
          {
            local: true
          }
        );
      }
    });
    watch(
      () => fieldHeight.value,
      () => {
        onFieldResize();
      }
    );
    watch(
      () => props.modelValue,
      (updated) => {
        contents.value = updated || "";
      },
      { immediate: true }
    );
    watch(
      () => contents.value,
      (updated) => {
        emit("update:modelValue", updated);
      }
    );
    watch(
      () => isSubmitting.value,
      (is) => {
        if (is) {
          emojiMenuOpen.value = false;
        }
      }
    );
    const onReplyClose = () => {
      isReplyTo.value = void 0;
      isReplyToContent.value = void 0;
    };
    const malarkeyChatInputFieldBindings = computed(() => ({
      ...malarkeyChatInputFieldDefaults,
      disabled: !conversation.value,
      hideDetails: true,
      readonly: isSubmitting.value,
      loading: isSubmitting.value,
      placeholder: props.placeholder,
      maxHeight: 200,
      clearable: !!conversation.value && !isSubmitting.value && !!isUpdateOf.value,
      persistentClear: !!conversation.value && !isSubmitting.value && !!isUpdateOf.value,
      enterkeyhint: "send",
      autocomplete: "off",
      autocorrect: "off",
      spellcheck: true
    }));
    const onFieldCleared = () => {
      contents.value = "";
      isReplyTo.value = void 0;
      isReplyToContent.value = void 0;
      isUpdateOf.value = void 0;
      triggerRef(isUpdateOf);
    };
    return {
      formElemBindings,
      onFormSubmit,
      contents,
      hasContents,
      isSubmitting,
      malarkeyChatInputFieldBindings,
      form,
      field,
      onFieldKeydown,
      onFieldKeyup,
      onFieldResize,
      updateFieldHeight,
      focus,
      doFormSubmit,
      emojiMenuOpen,
      selectEmoji,
      emojiButtonDisabled,
      emojiGroupNames,
      emojiStaticTexts,
      emojiPickerTheme,
      onFieldFocus,
      onFieldBlur,
      isReplyTo,
      isReplyToContent,
      replyingToQuote,
      onReplyClose,
      onFieldCleared
    };
  }
});
const _hoisted_1 = {
  key: 0,
  class: "m-chat-input-quoted-anchor"
};
const _hoisted_2 = { class: "m-chat-input-quoted-wrapper" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = /* @__PURE__ */ createElementVNode("input", {
  type: "submit",
  name: "_submit",
  style: { "display": "none" }
}, null, -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_alert = resolveComponent("v-alert");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_EmojiPicker = resolveComponent("EmojiPicker");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_textarea = resolveComponent("v-textarea");
  const _directive_mutate = resolveDirective("mutate");
  return openBlock(), createElementBlock("form", mergeProps({ ref: "form" }, _ctx.formElemBindings, {
    onSubmit: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.onFormSubmit && _ctx.onFormSubmit(...args), ["stop"]))
  }), [
    _ctx.isReplyTo ? (openBlock(), createElementBlock("div", _hoisted_1, [
      createElementVNode("div", _hoisted_2, [
        createVNode(_component_v_alert, {
          border: "start",
          density: "compact",
          variant: "elevated",
          closable: "",
          "onClick:close": _ctx.onReplyClose
        }, {
          default: withCtx(() => [
            createElementVNode("span", { innerHTML: _ctx.replyingToQuote }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["onClick:close"])
      ])
    ])) : createCommentVNode("", true),
    _hoisted_4,
    withDirectives((openBlock(), createBlock(_component_v_textarea, mergeProps({
      ref: "field",
      modelValue: _ctx.contents,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.contents = $event)
    }, _ctx.malarkeyChatInputFieldBindings, {
      onKeyup: _ctx.onFieldKeyup,
      onKeydown: _ctx.onFieldKeydown,
      onFocus: _ctx.onFieldFocus,
      onBlur: _ctx.onFieldBlur,
      onResize: _ctx.updateFieldHeight,
      onInput: _ctx.updateFieldHeight,
      "onClick:clear": _ctx.onFieldCleared
    }), {
      "append-inner": withCtx(() => [
        createVNode(_component_v_menu, {
          modelValue: _ctx.emojiMenuOpen,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.emojiMenuOpen = $event),
          "offset-y": "",
          top: "",
          "close-on-content-click": false
        }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_btn, mergeProps({
              icon: "",
              "x-small": "",
              variant: "text",
              density: "compact"
            }, props, { disabled: _ctx.emojiButtonDisabled }), {
              default: withCtx(() => [
                createVNode(_component_v_icon, null, {
                  default: withCtx(() => [
                    createTextVNode("mdi-emoticon-excited-outline")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1040, ["disabled"])
          ]),
          default: withCtx(() => [
            createVNode(_component_v_card, null, {
              default: withCtx(() => [
                createVNode(_component_EmojiPicker, {
                  native: true,
                  "group-names": _ctx.emojiGroupNames,
                  "static-texts": _ctx.emojiStaticTexts,
                  theme: _ctx.emojiPickerTheme,
                  onSelect: _ctx.selectEmoji
                }, null, 8, ["group-names", "static-texts", "theme", "onSelect"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 16, ["modelValue", "onKeyup", "onKeydown", "onFocus", "onBlur", "onResize", "onInput", "onClick:clear"])), [
      [
        _directive_mutate,
        _ctx.onFieldResize,
        void 0,
        {
          attr: true,
          child: true,
          immediate: true
        }
      ]
    ])
  ], 16);
}
const MalarkeyChatInputForm = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyChatInputForm.vue"]]);
export {
  MalarkeyChatInputForm as default
};
//# sourceMappingURL=MalarkeyChatInputForm.es.js.map
